import { render } from "./TeoAdmin.vue?vue&type=template&id=66c6002b"
import script from "./TeoAdmin.vue?vue&type=script&lang=js"
export * from "./TeoAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__